import type { AutoApplyClientData } from '../ssrData';

export function validateSSRData(
    data: AutoApplyClientData | undefined,
): asserts data is AutoApplyClientData {
    if (!data?.initialState) {
        throw new Error(
            'Missing window.__AUTO_APPLY_DATA__ — server SSR did not inject data. ' +
                'This usually means the SSR response was interrupted or the server failed.',
        );
    }
}
